/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import { type ReactNode, useEffect, useState } from 'react';
import { EvaluationLicenseContext } from '../../contexts/EvaluationLicenseContext';

export function EvaluationLicense( { children }: { children: ReactNode } ): ReactNode {
	const [ evaluationLicense, setEvaluationLicense ] = useState( '' );

	useEffect( () => {
		// @ts-expect-error EVALUATION_LICENSE_ENDPOINT variable is injected by vite.
		fetch( EVALUATION_LICENSE_ENDPOINT )
			.then( response => response.json() )
			.then( response => setEvaluationLicense( response.licenseKeyV3 ) );
	}, [] );

	return (
		<EvaluationLicenseContext.Provider value={ evaluationLicense }>
			{ children }
		</EvaluationLicenseContext.Provider>
	);
}
